<dff-side [observable]="vm$">
  @if (vm$ | async; as vm) {
    <dff-side-titel>{{ vm.sideTitel }}</dff-side-titel>
    <panel>
      @if (visSpinner) {
        <mat-spinner class="mat-spinner"></mat-spinner>
      }
      <div id="chart"><!-- Må ikke skjules ved visning af spinner, da Highcharts skal kunne rendere i elementet --></div>
      @if (!visSpinner) {
        <div [innerHTML]="vm.grafBeskrivelse | trustHtml"></div>
      }
    </panel>
    <div class="side-tekst" [innerHTML]="vm.sideTekst | trustHtml"></div>
  }
</dff-side>
